module.exports = __webpack_public_path__ + "img/guanwang_icon_xiazai.a0ef7861.svg";